<div class="" (keydown.enter)="onClick()">
  <p-card>
    <div class="flex flex-col items-center gap-4 justify-between h-[60vh] w-[80vw]
           sm:h-[70vh] sm:w-[25vw] p-1 lg:p-4">
      <img alt="OCOP" class="max-w-full h-auto" height="96" ngSrc="./assets/images/ocop_logo.png" priority width="294"/>
      @if (showLoading()) {
        <p-progress-spinner ariaLabel="loading"
                            [style]="{
            '--p-progressspinner-color-one': '#000',
            '--p-progressspinner-color-two': '#E41B2E',
            '--p-progressspinner-color-three': '#000',
            '--p-progressspinner-color-four': '#E41B2E',
            width: '50px',
            height: '50px'
          }"
        />
      }
      <p [style.color]="messageColor()" class="text-xs lg:text-sm text-center whitespace-pre-line">
        {{ message() }}
      </p>
      @if (showButton()) {
        <p-button (click)="onClick()" (keydown.enter)="onClick()" class="w-full" styleClass="btn-gray" [label]="buttonLabel()">
          @switch (buttonIcon()) {
            @case ('login') {
              <app-icon-login/>
            }
            @case ('arrow-left') {
              <app-icon-arrow-left/>
            }
          }
        </p-button>
      }
    </div>
  </p-card>
</div>
